import type { MarketingSection } from '@mc/api'

export const getMarketingRow = (
  rows: MarketingSection[] | undefined,
  slug: string,
) => rows?.find((row) => row.slug === slug)
